var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsPanelExpandWest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.66667C20 0.746192 19.2538 0 18.3333 0H1.66667C0.746193 0 0 0.746192 0 1.66667V18.3333C0 19.2538 0.746193 20 1.66667 20H18.3333C19.2538 20 20 19.2538 20 18.3333V1.66667ZM18.3333 8.75V10.4167H14.1667V12.5L11.6667 9.58333L14.1667 7.08333V8.75H18.3333ZM1.66667 1.66667H10V18.3333H1.66667V1.66667Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPanelExpandWest);
export default __webpack_public_path__ + "static/media/icons_panel_expand_west.fa83a29b.svg";
export { ForwardRef as ReactComponent };